var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/pull-to-refresh.tsx";
const _excluded = ["children", "onRefresh"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useCallback } from 'react';
import PTRComponent from 'react-simple-pull-to-refresh';
import { Spinner } from 'soapbox/components/ui';
/**
 * PullToRefresh:
 * Wrapper around a third-party PTR component with Soapbox defaults.
 */
const PullToRefresh = _ref => {
  let {
      children,
      onRefresh
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const handleRefresh = useCallback(() => {
    if (onRefresh) {
      return onRefresh();
    } else {
      // If not provided, do nothing
      return Promise.resolve();
    }
  }, [onRefresh]);
  return /*#__PURE__*/React.createElement(PTRComponent, _extends({
    onRefresh: handleRefresh,
    pullingContent: /*#__PURE__*/React.createElement(React.Fragment, null)
    // `undefined` will fallback to the default, while `<></>` will render nothing
    ,
    refreshingContent: onRefresh ? /*#__PURE__*/React.createElement(Spinner, {
      size: 30,
      withText: false,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 32,
        columnNumber: 38
      }
    }) : /*#__PURE__*/React.createElement(React.Fragment, null),
    pullDownThreshold: 67,
    maxPullDownDistance: 95,
    resistance: 2
  }, rest, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(React.Fragment, null, children));
};
export default PullToRefresh;